<template>
  <div class="left-menu-wrapper" :class="{ 'dark-mode': isDarkMode }">
    <v-icon class="toggle-icon" :icon="isSidebarClosed ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left'
      " :style="toggleIconPosition" @click="toggleDrawer"></v-icon>

    <div :class="['sidebar', { close: isSidebarClosed }]">
      <div class="logo-div" v-if="!isSidebarClosed">
        <div class="img-wrap">
          <v-img aspect-ratio="16/9" :src="currentLogo.logo" alt="logo"></v-img>
        </div>
      </div>

      <div class="logo-div2" v-if="isSidebarClosed">
        <div class="img-wrap2">
          <v-img :src="currentLogo.logoIcon" alt="logo"></v-img>
        </div>
      </div>

      <ul class="nav-list">
        <li
          v-for="item in filteredNavigationItems"
          :key="item.title"
          :class="{ show: item.isVisible }"
        >
          <div
            v-if="item.children"
            class="icon-link"
            :class="{
              'active-item-sub': item.title === activeMenu ||
                (item.children && item.children.some(child => isChildRouteActive(child.route)))
            }"
            @click="toggleSubmenuByTitle(item.title)"
          >
            <div class="link">
              <img
                :src="(item.title === activeMenu ||
                  (item.children && item.children.some(child => isChildRouteActive(child.route))))
                  ? item.activeImage
                  : item.image"
              />
              <span class="link-name">{{ item.title }}</span>
              <v-icon
                class="submenu-arrow"
                :icon="item.isVisible ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                :color="isDarkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.55)'"
                size="18"
              />
            </div>
          </div>
          <ul v-if="item.children" :class="{ show: item.isVisible }" class="sub-menu" @click.stop>
            <li v-for="(childItem, childIndex) in item.children" :key="childIndex">
              <router-link v-if="childItem.route" :to="typeof childItem.route === 'string' ? childItem.route : childItem.route" class="sub-link">
                <img :src="isChildRouteActive(childItem.route) ? childItem.activeImage : childItem.image" />
                <span :class="{ 'active-text-child': isChildRouteActive(childItem.route) }">
                  {{ childItem.title }}
                </span>
              </router-link>
              <span v-else class="sub-link">
                <img :src="childItem.image" />
                <span :class="{ 'active-text': $route.path === childItem.route }">{{ childItem.title }}</span>
              </span>
            </li>
          </ul>
          <div class="icon-link" v-else :class="{ 'active-item': item.title === activeMenu }">
            <router-link v-if="item.route" :to="item.route" class="link">
              <img :src="item.title === activeMenu ? item.activeImage : item.image
                " />
              <span class="link-name" :class="{ 'active-text': item.title === activeMenu }">{{ item.title }}</span>
            </router-link>
            <div v-else class="link" @click="handleClick(item)">
              <img :src="item.image" />
              <div class="eda-content">
                <span class="link-name">{{ item.title }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="left-footer" v-if="!isSidebarClosed">
        <div class="footer-img">
          <v-img 
            aspect-ratio="16/9" 
            :src="selectedTenant === 'ExxonMobil' ? currentLogo.exxonLogo : selectedTenant === 'adnoc_demo' ? currentLogo.adnocLogo : currentLogo.tenantName" 
            alt="logo"
            :style="selectedTenant === 'adnoc_demo' ? { width: '30%', height: '30%', margin: '0 auto' } : {}"
          ></v-img>
        </div>
      </div>
      <div class="logo-div2 " v-else>
        <div class="img-wrap2">
          <v-img :src="selectedTenant === 'ExxonMobil' ? currentLogo.exxonLogoIcon : selectedTenant === 'adnoc_demo' ? currentLogo.adnocLogoIcon : currentLogo.smallLogo" alt="logo"></v-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../../eventBus.js";
import { getTenantPrefix } from "../../../utils/tenant.js";
import { PERMISSION_WRITE_QC } from "../../../utils/permissions.js";

const OPEN_SUBMENUS_STORAGE_KEY = "leftMenuOpenSubmenus";

export default {
  name: "LeftMenu",
  data() {
    return {
      isVisible: false,
      isSidebarClosed: true,
      screenWidth: 0,
      drawer: true,
      rail: false,
      miniVariant: false,
      activeMenu: '',
      openSubmenu: null,
      logo: {
        logo: require("../../../assets/Images/LeftMenu/logo.png"),
        logoDark: require("../../../assets/Images/LeftMenu/logo-dark.png"),
        logoIcon: require("../../../assets/Images/LeftMenu/logoicon.png"),
        logoIconDark: require("../../../assets/Images/LeftMenu/logoicon-dark.png"),
        tenantName: require("../../../assets/Svg/LeftMenu/logo-full.svg"),
        tenantNameDark: require("../../../assets/Svg/LeftMenu/logo-full-dark.svg"),
        clientLogo: require("../../../assets/Images/LeftMenu/Client Logo.png"),
        exxonLogo: require("../../../assets/Svg/LeftMenu/exxonLogo.svg"),
        exxonLogoIcon: require("../../../assets/Svg/LeftMenu/exxonIcon.svg"),
        smallLogo: require("../../../assets/Images/LeftMenu/tenant-name.png"),
        adnocLogo: require("../../../assets/Svg/LeftMenu/adnocExpand.svg"),
        adnocLogoIcon: require("../../../assets/Svg/LeftMenu/adnocCollapsed.svg"),
      },
      navigationItems: [
        {
          title: "Data Management",
          route: `/${this.tenantId}/data-management`,
          image: require("../../../assets/Svg/LeftMenu/data-management.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        },
        {
          title: "QA/QC",
          route: `/${this.tenantId}/qaqc`,
          image: require("../../../assets/Svg/LeftMenu/QA-QC.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/QA-QC-active.svg"),
        },
        {
          title: "QA/QC Overview",
          route: `/${this.tenantId}/qaqc/overview`,
          image: require("../../../assets/Svg/LeftMenu/QA-QC.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/QA-QC-active.svg"),
        },
        {
          title: "Studio",
          route: `/${this.tenantId}/Fluidsdata-studio`,
          image: require("../../../assets/Svg/LeftMenu/studio.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        },
        {
          title: "Agentic AI Dashboards",
          route: `/${this.tenantId}/agentic-dashboard`,
          image: require("../../../assets/Svg/LeftMenu/dashboard.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        },
        // {
        //   title: "Agentic Dashboard",
        //   route: `/${this.tenantId}/agentic-dashboard`,
        //   image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
        //   activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
        // },
        {
          title: "Exploratory Data Analysis",
          image: require("../../../assets/Svg/LeftMenu/eda.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/eda-active.svg"),
          isVisible: false,
          children: [
            {
              title: "Inventory Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/inventory-analysis`,
              image: require("../../../assets/Svg/LeftMenu/inventory.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
            },
            {
              title: "2D Histogram/KDE Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/twodhistogram-kde`,
              image: require("../../../assets/Svg/LeftMenu/twod.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/twod-active.svg"),
            },
            {
              title: "Statistical Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/statistical-analysis`,
              image: require("../../../assets/Svg/LeftMenu/statistical.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
            },
            {
              title: "Correlation Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/correlation-analysis`,
              image: require("../../../assets/Svg/LeftMenu/correlation.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
            },
            {
              title: "Heatmap Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/heatmap-analysis`,
              image: require("../../../assets/Svg/LeftMenu/treemap.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
            },
            {
              title: "Bubble Plot Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/bubble-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/bubble.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
            },
            {
              title: "3D Plot Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/3d-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/threed.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/threed-active.svg"),
            },
            {
              title: "Composition Gradient Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/composition-gradient-analysis`,
              image: require("../../../assets/Svg/LeftMenu/depth.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/depth-active.svg"),
            },
           
          ],
          
        },
        {
          title: "Fluids Intelligence",
          image: require("../../../assets/Images/LeftMenu/fdpal.svg"),
          activeImage: require("../../../assets/Images/LeftMenu/fdpal-active.svg"),
          isVisible: false,
          children: [
            {
              title: "PVT Property Prediction",
              route: `/${this.tenantId}/pvt-prediction`,
              image: require("../../../assets/Svg/LeftMenu/pvt-prediction.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/pvt-prediction-active.svg"),
            },
            {
              title: "Agentic AI",
              route: `/${this.tenantId}/fluidsIntelligence`,
              image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
            }
          ]
        },
      ],
    }
  },
  props: {
    menu: {
      type: Boolean,
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(newRoute) {
        this.updateNavigationItems();
        this.handleRouteChange(newRoute.path);
        this.applyOpenSubmenuState();
      }
    },
    "$route.path"(newPath) {
      this.handleRouteChange(newPath);
      let activeItem = null;
      activeItem = this.navigationItems.find((item) => newPath === item.route);

      if (!activeItem) {
        this.navigationItems.forEach((item) => {
          if (item.children) {
          const  activeSubItem = item.children.find(
              (subItem) => newPath === subItem.route
            );
            if (activeSubItem) {
              activeItem = item;
              if (activeSubItem.title === "PVT Property Prediction") {
                localStorage.setItem("activeMenu", activeSubItem.title);
                localStorage.setItem("lastActiveMenu", activeSubItem.title);
                this.activeMenu = activeSubItem.title;
              } else {
                localStorage.setItem("activeMenu", item.title);
                localStorage.setItem("lastActiveMenu", item.title);
                this.activeMenu = item.title;
              }
            }
          }
        });
      } else {
        const currentActiveMenu = this.activeMenu;
        localStorage.setItem("lastActiveMenu", currentActiveMenu);
        localStorage.setItem("activeMenu", activeItem.title);
      }
    },
  },
  computed: {
    ...mapGetters("tenantId", ["getSelectedTenant"]),
    ...mapGetters("darkMode", ["isDarkMode"]),
    toggleIconPosition() {
      return this.drawer ? "right: -12px;" : "left: 52px;";
    },
    tenantId() {
      return this.$route.path.split("/")[1] || getTenantPrefix();
    },
    selectedTenant() {
      return this.getSelectedTenant?.name || "";
    },
    currentLogo() {
      if (this.isDarkMode) {
        return {
          logo: this.logo.logoDark,
          logoIcon: this.logo.logoIconDark,
          tenantName: this.logo.tenantNameDark,
          clientLogo: this.logo.clientLogo,
          exxonLogo: this.logo.exxonLogo,
          exxonLogoIcon: this.logo.exxonLogoIcon,
          smallLogo: this.logo.smallLogo,
          adnocLogo: this.logo.adnocLogo,
          adnocLogoIcon: this.logo.adnocLogoIcon,
        };
      }
      return this.logo;
    },
    currentNavigationItems() {
      return this.navigationItems.map(item => {
        const newItem = { ...item };

        if (item.image && item.activeImage) {
          newItem.image = this.getDarkModeIcon(item.image, item.title);
          newItem.activeImage = this.getDarkModeIcon(item.activeImage, item.title);
        }

        if (item.children) {
          newItem.children = item.children.map(child => ({
            ...child,
            image: this.getDarkModeIcon(child.image, child.title),
            activeImage: this.getDarkModeIcon(child.activeImage, child.title)
          }));
        }
        
        return newItem;
      });
    },
    filteredNavigationItems() {
    const currentTenant = this.selectedTenant || localStorage.getItem("tenantName");
    return this.currentNavigationItems
      .map((item) => {
        if (item.children) {
          // Filter child routes based on permissions and tenant restrictions
          const filteredChildren = item.children.filter((child) => {
            // Check permission first
            const hasPermission = this.$store.getters["tenantId/hasPermission"](this.getPermissionKey(child.title));
            if (!hasPermission) return false;
            
            // PVT Property Prediction is only available for Fluidsdata tenant
            if (child.title === "PVT Property Prediction" && currentTenant !== "Fluidsdata") {
              return false;
            }
            
            return true;
          });
          
          // Only include parent if it has visible children
          if (filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
        } else {
          if (this.$store.getters["tenantId/hasPermission"](this.getPermissionKey(item.title))) {
            return item;
          }
        }
        return null;
      })
      .filter(Boolean);
  }
  },
  methods: {
    getDarkModeIcon(iconPath, title) {
      if (!this.isDarkMode) return iconPath;

      const darkModeIconMap = {
        'pvt.svg': require("../../../assets/Svg/LeftMenu/pvt.svg"),
        'pvt-active.svg': require("../../../assets/Svg/LeftMenu/pvt-active.svg"),
        'data-management.svg': require("../../../assets/Svg/LeftMenu/data-management.svg"),
        'data-management-active.svg': require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        'studio.svg': require("../../../assets/Svg/LeftMenu/studio.svg"),
        'studio-active.svg': require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        'dashboard.svg': require("../../../assets/Svg/LeftMenu/dashboard.svg"),
        'dashboard-active.svg': require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        'eda.svg': require("../../../assets/Svg/LeftMenu/eda.svg"),
        'eda-active.svg': require("../../../assets/Svg/LeftMenu/eda-active.svg"),
        'inventory.svg': require("../../../assets/Svg/LeftMenu/inventory.svg"),
        'inventory-active.svg': require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
        'twod.svg': require("../../../assets/Svg/LeftMenu/twod.svg"),
        'twod-active.svg': require("../../../assets/Svg/LeftMenu/twod-active.svg"),
        'statistical.svg': require("../../../assets/Svg/LeftMenu/statistical.svg"),
        'statistical-active.svg': require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
        'correlation.svg': require("../../../assets/Svg/LeftMenu/correlation.svg"),
        'correlation-active.svg': require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
        'treemap.svg': require("../../../assets/Svg/LeftMenu/treemap.svg"),
        'treemap-active.svg': require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
        'bubble.svg': require("../../../assets/Svg/LeftMenu/bubble.svg"),
        'bubble-active.svg': require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
        'threed.svg': require("../../../assets/Svg/LeftMenu/threed.svg"),
        'threed-active.svg': require("../../../assets/Svg/LeftMenu/threed-active.svg"),
        'depth.svg': require("../../../assets/Svg/LeftMenu/depth.svg"),
        'depth-active.svg': require("../../../assets/Svg/LeftMenu/depth-active.svg"),
      };

      const fileName = iconPath.split('/').pop();
      return darkModeIconMap[fileName] || iconPath;
    },
    
    getPermissionKey(title) {
    const permissionMap = {
      "Data Management": "ViewDataManagement",
      "QA/QC": PERMISSION_WRITE_QC,
      "QA/QC Overview": PERMISSION_WRITE_QC,
      "Studio": "ViewStudio",
      "Dashboards": "ViewDashboards",
      "Agentic AI Dashboards": "ViewDashboards",
      "Exploratory Data Analysis": "ViewEDA",
      "Inventory Analysis": "ViewEDA",
      "Correlation Analysis": "ViewEDA",
      "Statistical Analysis": "ViewEDA",
      "Composition Gradient Analysis": "ViewEDA",
      "2D Histogram/KDE Analysis": "ViewEDA",
      "Heatmap Analysis": "ViewEDA",
      "Bubble Plot Analysis": "ViewEDA",
      "3D Plot Analysis": "ViewEDA",
      "Security": "ManageRoles",
      "User Management": "ManageUsers",
      "Role Management": "ManageRoles",
      "Fluids Intelligence": "ViewDataManagement",
      "PVT Property Prediction": "ViewDataManagement",
      "Agentic AI": "ViewDataManagement"
    };

    return permissionMap[title] || null;
  },
    updateNavigationItems() {
      const currentTenantId = this.tenantId;
      this.navigationItems = [
        {
          title: "Data Management",
          route: `/${currentTenantId}/data-management`,
          image: require("../../../assets/Svg/LeftMenu/data-management.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        },
        {
          title: "QA/QC",
          route: `/${currentTenantId}/qaqc/overview`,
          image: require("../../../assets/Svg/LeftMenu/QA-QC.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/QA-QC-active.svg"),
        },
        {
          title: "Studio",
          route: `/${currentTenantId}/Fluidsdata-studio`,
          image: require("../../../assets/Svg/LeftMenu/studio.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        },
        {
          title: "Agentic AI Dashboards",
          route: `/${currentTenantId}/agentic-dashboard`,
          image: require("../../../assets/Svg/LeftMenu/dashboard.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        },
        // {
        //   title: "Agentic Dashboard",
        //   route: `/${currentTenantId}/agentic-dashboard`,
        //   image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
        //   activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
        // },
        {
          title: "Exploratory Data Analysis",
          image: require("../../../assets/Svg/LeftMenu/eda.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/eda-active.svg"),
          isVisible: false,
          children: [
            {
              title: "Inventory Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/inventory-analysis`,
              image: require("../../../assets/Svg/LeftMenu/inventory.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
            },
            {
              title: "2D Histogram/KDE Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/twodhistogram-kde`,
              image: require("../../../assets/Svg/LeftMenu/twod.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/twod-active.svg"),
            },
            {
              title: "Statistical Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/statistical-analysis`,
              image: require("../../../assets/Svg/LeftMenu/statistical.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
            },
            {
              title: "Correlation Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/correlation-analysis`,
              image: require("../../../assets/Svg/LeftMenu/correlation.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
            },
            {
              title: "Heatmap Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/heatmap-analysis`,
              image: require("../../../assets/Svg/LeftMenu/treemap.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
            },
            {
              title: "Bubble Plot Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/bubble-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/bubble.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
            },
            {
              title: "3D Plot Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/3d-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/threed.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/threed-active.svg"),
            },
            {
              title: "Composition Gradient Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/composition-gradient-analysis`,
              image: require("../../../assets/Svg/LeftMenu/depth.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/depth-active.svg"),
            },
          ],
        },
        {
          title: "Fluids Intelligence",
          image: require("../../../assets/Images/LeftMenu/fdpal.svg"),
          activeImage: require("../../../assets/Images/LeftMenu/fdpal-active.svg"),
          isVisible: false,
          children: [
            {
              title: "PVT Property Prediction",
              route: `/${currentTenantId}/pvt-prediction`,
              image: require("../../../assets/Svg/LeftMenu/pvt-prediction.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/pvt-prediction-active.svg"),
            },
            {
              title: "Agentic AI",
              route: `/${this.tenantId}/fluidsIntelligence`,
              image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
            }
          ]
        },
      ];
      this.applyOpenSubmenuState();
    },
    handleClick(item) {
      if (item.children) {
        this.toggleSubmenuByTitle(item.title);
      }
    },
    isChildRouteActive(childRoute) {
      if (!childRoute) return false;
      const currentPath = this.$route.path;
      const routeBase = String(childRoute).split("?")[0];
      return currentPath === routeBase || currentPath.startsWith(`${routeBase}/`);
    },
    getOpenSubmenuTitles() {
      try {
        const raw = localStorage.getItem(OPEN_SUBMENUS_STORAGE_KEY);
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    },
    saveOpenSubmenuTitles(titles) {
      localStorage.setItem(OPEN_SUBMENUS_STORAGE_KEY, JSON.stringify(titles));
    },
    applyOpenSubmenuState() {
      const openTitles = this.getOpenSubmenuTitles();
      let titlesChanged = false;

      this.navigationItems.forEach((item, index) => {
        if (!item.children) return;

        const childActive = item.children.some(
          (child) => child.route && this.isChildRouteActive(child.route)
        );
        if (childActive && !openTitles.includes(item.title)) {
          openTitles.push(item.title);
          titlesChanged = true;
        }

        const shouldOpen = openTitles.includes(item.title) || childActive;
        item.isVisible = shouldOpen;
        if (shouldOpen) {
          this.openSubmenu = index;
        }
      });

      if (titlesChanged) {
        this.saveOpenSubmenuTitles(openTitles);
      }

      this.navigationItems = [...this.navigationItems];
    },
    toggleSubmenuByTitle(title) {
      const index = this.navigationItems.findIndex((item) => item.title === title);
      if (index === -1) return;

      const item = this.navigationItems[index];
      item.isVisible = !item.isVisible;

      let openTitles = this.getOpenSubmenuTitles();
      if (item.isVisible) {
        if (!openTitles.includes(title)) openTitles.push(title);
        this.openSubmenu = index;
      } else {
        openTitles = openTitles.filter((t) => t !== title);
        if (this.openSubmenu === index) this.openSubmenu = null;
      }

      this.saveOpenSubmenuTitles(openTitles);
      this.navigationItems = [...this.navigationItems];
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      this.$emit("drawerStateChanged", this.drawer);
      this.isSidebarClosed = !this.isSidebarClosed;
      this.$emit("drawerHold", this.drawer);

      eventBus.emit("mainSidebarStateChanged", this.drawer);

      if (!this.isSidebarClosed) {
        this.applyOpenSubmenuState();
      }

      eventBus.emit("resizeChart");
    },
    checkScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.drawer = false;
        this.isSidebarClosed = true;
      } else if (this.screenWidth > 768) {
        if (this.menu) {
          this.drawer = true;
          this.isSidebarClosed = false;
        } else {
          this.drawer = true;
          this.isSidebarClosed = false;
        }
        this.toggleDrawer()
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.toggleDrawer();
      }
    },
    handleRouteChange(newPath) {
      this.updateNavigationItems();

      let activeItem = null;
      let activeSubItem = null;

      activeItem = this.navigationItems.find((item) => {
        if (newPath === item.route) return true;
        if (item.title === "Agentic AI Dashboards" && item.route && newPath.startsWith(item.route)) {
          return true;
        }
        return false;
      });

      if (!activeItem) {
        this.navigationItems.forEach((item, index) => {
          if (item.children) {
            const foundSubItem = item.children.find(
              (subItem) => newPath === subItem.route || 
                          (newPath.includes('exploratory-data-analysis') && subItem.route.includes(newPath.split('?')[0]))
            );
            if (foundSubItem) {
              activeItem = item;
              activeSubItem = foundSubItem;
              item.isVisible = true;
              this.openSubmenu = index;
              this.activeMenu = item.title;
              localStorage.setItem("activeMenu", item.title);
              localStorage.setItem("lastActiveMenu", item.title);
            }
          }
        });
        
        if (newPath.startsWith(`/${this.tenantId}/qaqc/`)) {
          const overviewItem = this.navigationItems.find(item => item.title === "QA/QC Overview" && item.route && newPath === item.route);
          activeItem = overviewItem || this.navigationItems.find(item => item.title === "QA/QC");
          if (activeItem) {
            this.activeMenu = activeItem.title;
            localStorage.setItem("activeMenu", activeItem.title);
            localStorage.setItem("lastActiveMenu", activeItem.title);
          }
        }

        if (newPath === `/${this.tenantId}/pvt-prediction` || newPath.startsWith(`/${this.tenantId}/pvt-prediction`)) {
          if (activeSubItem && activeSubItem.title === "PVT Property Prediction") {
            this.activeMenu = activeSubItem.title;
            localStorage.setItem("activeMenu", activeSubItem.title);
            localStorage.setItem("lastActiveMenu", activeSubItem.title);
          }
        }
      } else {
        const currentActiveMenu = this.activeMenu;
        localStorage.setItem("lastActiveMenu", currentActiveMenu);
        localStorage.setItem("activeMenu", activeItem.title);
        this.activeMenu = activeItem.title;
      }

      this.applyOpenSubmenuState();

      const activeMenu = localStorage.getItem("activeMenu") || "Data Management";
      const lastActiveMenu = localStorage.getItem("lastActiveMenu");
      const routePath = this.$route.path;

      let routeDrivenMenu = "";
      if (routePath.startsWith(`/${this.tenantId}/data-management`)) {
        routeDrivenMenu = "Data Management";
      } else if (routePath.startsWith(`/${this.tenantId}/assets`)) {
        routeDrivenMenu = "Data Management";
      } else if (routePath === `/${this.tenantId}/qaqc` || routePath.startsWith(`/${this.tenantId}/qaqc/`)) {
        routeDrivenMenu = "QA/QC";
      } else if (routePath.startsWith(`/${this.tenantId}/Fluidsdata-studio`)) {
        routeDrivenMenu = "Studio";
      } else if (routePath.startsWith(`/${this.tenantId}/Dashboards`)) {
        routeDrivenMenu = "Dashboards";
      } else if (routePath.startsWith(`/${this.tenantId}/agentic-dashboard`)) {
        routeDrivenMenu = "Agentic AI Dashboards";
      } else if (routePath.startsWith(`/${this.tenantId}/exploratory-data-analysis`)) {
        routeDrivenMenu = "Exploratory Data Analysis";
      } else if (routePath.startsWith(`/${this.tenantId}/pvt-prediction`)) {
        routeDrivenMenu = "PVT Property Prediction";
      } else if (routePath.startsWith(`/${this.tenantId}/fluidsIntelligence`)) {
        routeDrivenMenu = "Fluids Intelligence";
      }

      if (routeDrivenMenu) {
        if (routeDrivenMenu === "Dashboards") {
          this.activeMenu = "Agentic AI Dashboards";
          localStorage.setItem("activeMenu", "Dashboards");
          localStorage.setItem("lastActiveMenu", "Dashboards");
        } else {
          this.activeMenu = routeDrivenMenu;
          localStorage.setItem("activeMenu", routeDrivenMenu);
          localStorage.setItem("lastActiveMenu", routeDrivenMenu);
        }
      } else if (lastActiveMenu === "Data Management" || lastActiveMenu === "PVT Data Visualization") {
        this.activeMenu = "Data Management";
        localStorage.setItem("activeMenu", "Data Management");
      } else if (lastActiveMenu === "Fluidsdatapal") {
        this.activeMenu = lastActiveMenu;
      }

      if (activeSubItem && activeItem) {
        activeItem.isVisible = true;
      }
    },
  },
  mounted() {
    if (localStorage.getItem("activeMenu") === "PVT Data Visualization") {
      localStorage.setItem("activeMenu", "Data Management");
    }
    if (localStorage.getItem("lastActiveMenu") === "PVT Data Visualization") {
      localStorage.setItem("lastActiveMenu", "Data Management");
    }
    this.handleRouteChange(this.$route.path);
    this.checkScreenWidth();
    window.addEventListener("resize", this.checkScreenWidth);
    window.addEventListener("keydown", this.handleKeydown);
    this.applyOpenSubmenuState();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenWidth);
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>
